module.exports = __webpack_public_path__ + "img/banner_5.ea255d7e.jpg";